import { Component } from 'react';
import { userData } from '../../Redux/services/generalService';
import service from '../../core/service';
import routes from '../../core/routes';

interface IProps {
  userData: any,
  dispatch?: any,
}
interface IState {

}
export class PreviewController extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
  }
  state: IState = {

  };


 


  getProfile = () => {
    return async  (dispatch: any) => {
        try {
            const response = await service.User.profile();
            if (response) {
                dispatch(userData(response?.data?.data));
                window.location.href = `${routes.TICKETING}`

            }
        } catch (error: any) {
            if (error && error.status === 404) {
              
            }
        }
    };
};


}
export default PreviewController;